import React, {Component} from 'react';
import Country from './Country';
import '../css/Header.css';
import '../css/bootstrap-theme.min.css';
import '../css/bootstrap.min.css';
import Vetradent from '../assets/Vetradent.png';
import Dechra from '../assets/Dechra.png';




class Header extends Component{
    constructor(props){
        super(props);


        this.setCountry = this.setCountry.bind(this);
        this.setLanguage = this.setLanguage.bind(this);
        this.handleLink = this.handleLink.bind(this);

    }

    setCountry(country){
        this.props.setCountry(country);
    }

    setLanguage(language){

        this.props.setLanguage(language);
    }

    handleLink(e){
        var page_id = e.currentTarget.getAttribute("data");
        this.props.setPage(page_id);

    }

    render(){

        var settings = this.props.Settings;
        var content = this.props.Content;
        var page = this.props.Page;

        var text;
        var menus = [];
        var x;


        for(x=1;x<content.pages.length;++x){
            var page_link;
            var class_name = "";

            switch (x){
                case 1:
                    page_link = "how-it-works";
                    break;
                case 2:

                    page_link = "dental-health";
                    break;
                case 3:

                    page_link = "products";
                    break;
                case 4:

                    page_link = "about";
                    break;
                default:

                    page_link = "home";
                    break;
            }

            if (settings.language==="en"){
                text = content.pages[x].en;
            }else{
                text = content.pages[x].fr;
            }
            if(page == page_link){
                class_name = "active-tab"
            } else {
                class_name = "inactive-tab"
            }

            var tabs_class


              menus.push(
                  <div  className="tabs" key = {x}><a aria-label={page_link} onClick={this.handleLink} className={class_name}  data-title={text} data={page_link}>{text}</a></div>
              )

        }
        return(
            <div>
                <div className={"header-content"}>
                    <a aria-label="home page" onClick = {this.handleLink} data="home" className = "product-img" >
                        <span className="product-img-helper"></span>
                        <img  data={0} onClick={this.handleMenuClick}  src ={Vetradent} alt = "Vetradent"/>
                    </a>
                    <div  className={"header-column"}>
                        <Country Settings = {this.props.Settings} setCountry = {this.setCountry} setLanguage = {this.setLanguage} />

                        <div className = "menu-row">
                            {menus}
                        </div>
                    </div>
                    <div className={"brand-img"} >
                        <img src ={Dechra} alt = "Dechra"/>
                    </div>
                </div>
                <div className = "header-flavor"> </div>
            </div>

        )
    }




}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.js